/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:04:46
 */
export default {
  '序号': 'No.',
  'EPOS授权信息': 'EPOS Authorization Info',
  '汇总：': 'Sum',
  '剩余': 'Balance',
  '绑定类型：': 'Binding Type:',
  '剩余天数': 'Days Left ',
  '操作': 'Operation',
  '查看': 'Search',
  '店铺授权容量': 'Channel Authorization Quty',
  'WEB授权容量': 'WEB Authorization Quty',
  '移动授权容量': 'Mobile Authorization Quty',
  '合同编号': 'Contract No.',
  '开始/结束时间': 'Begin/End Time',
  'Android平板': 'Android Pad',
  'Android手机': 'Android Mobile',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': 'Authorization Info',
  '查看变更记录': 'Search Changing Records',
  '店铺授权清单': 'Channel Authorization List',
  '设备归属清单': 'Device Belonging List',
  '新增授权店铺': 'Add Authorized Channel',
  '管理所有店铺授权': 'Manage All Channel Authorization',
  '管理所有归属设备': 'Manage All Belonged Devices',
  '关闭': 'Close',
  '授权全部渠道': 'Authorize All Channels',
  '确认授权所有店铺？': 'Confirm authorize to all channels?',
  '操作日期': 'Operation Date',
  '类型': 'Type',
  '操作内容': 'Details',
  '操作人': 'Operator',
  '店铺编号': 'Channel No.',
  '店铺简称': 'Channel Abbr Name',
  '店铺全称': 'Channel Full Name',
  'WEB设备': 'WEB Devices',
  '移动': 'Mobile',
  '机器编号': 'Machine No.',
  '机器码': 'Machine Code',
  '设备类型': 'Device Type',
  '绑定类型': 'Binding Type',
  '绑定日期': 'Binding Date',
  '状态': 'Status',
  '余量：': 'Quty Balance',
  '（含扩容：': '(Include Expanding:',
  '该店铺不存在或已授权': 'This Channel does not Exsist or Authorized',
  '请输入': 'Enter',
  '授权设备类型': 'Authorizing Device Type',
  '绑定状态': 'Binding Status',
  '请选择': 'Select',
  '筛选': 'Filter',
  '清空': 'Clear',
  '返回': 'Return',
  '设备绑定列表': 'Device Binding List',
  '解除绑定': 'Unbind',
  '移出黑名单': 'Move from Black List',
  '加入黑名单': 'Add to Black List',
  '全选': 'Select All',
  '提示': 'Hint',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '正常': 'Normal',
  '白名单': 'White List',
  '黑名单': 'Black List',
  '激活码': 'Activate Code',
  '安卓手机': 'Android Mobile',
  '安卓平板': 'Android Pad',
  '禁用': 'Forbbiden',
  '启用': 'Enabled',
  'EPOS版本': 'EPOS Version',
  '企业': 'Company',
  '企业编号': 'Company No.',
  '设备机型': 'Device Type',
  '系统版本号': 'System Version',
  'EPOS版本号': 'EPOS Version',
  '数量': 'Quantity',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '',
  '允许登陆pos': 'Unbind with Activate code/Channel capacity in the past, to avoid channel pos quty exceed limitation, confirm the hint whether continue this operation?',
  '释放往期的激活码/店铺容量': 'Release Activate code/Channel Quty',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': 'Limit logging in EPos, need to unbound Activate code and channel belonging, confirm the hint whether continue this operation?',
  '是否解除绑定': 'Whether Unbind',
  '是否': 'Whether',
  '解绑成功': 'Unbounded',
  '店铺授权': 'Channel Authorization',
  '新增店铺授权': 'Add Channel Authorization',
  '总量': 'Total ',
  '授权日期': 'Authorization Date',
  '合同编号：': 'Contract No.:',
  '请输入合同编号': 'Enter Contract No.',
  '店铺编号：': 'Channel No.:',
  '请输入店铺编号': 'Enter Channel No.',
  '店铺授权列表': 'Channel Authorization List',
  'WEB限额': 'WEB Limitation',
  'WEB限额余量': 'WEB Limitation Balance',
  '移动限额': 'Mobile POS Limitation',
  '移动限额余量': 'Mobile POSLimitation Balance',
  '解除授权': 'Disauthorization',
  '扩容': 'Expand Quty',
  '移动扩容:': 'Mobile POS Expand Quty',
  'WEB扩容:': 'WEB Expand Quty',
  '扩容成功': 'Quty Expanded',
  '将影响已授权的店铺登录，是否确定调整': 'Will influence the login of authorized channel, whether confirm to adjust?',
  '登录记录查看': 'Loging Records Search',
  '请输入店铺简称': 'Enter Channel',
  '请输入收银员名称': 'Enter Salesman\'s Name',
  '请输入机器编号': 'Enter Machine No. ',
  '请输入版本号': 'Enter Version No.',
  '至': 'to',
  '开始日期': 'Begin Date',
  '结束日期': 'End Date',
  '搜索': 'Search',
  '登录时间': 'Login Time',
  '收银员': 'Salesman',
  '门店': 'Channel',
  '设备型号': 'Device Type',
  '系统版本': 'System Version',
  '经纬度': 'Longitude&Latitude',
  '定位地址': 'Locate Address',
  '最近一周': 'Last Week',
  '最近一个月': 'Last Month',
  '最近三个月': 'Last 3 Month',
  '含扩容：': 'Include Expanding：',
  '管理': 'Management',
  '已过期': 'Expired',
  '未生效': 'Not Active',
  '不足一天': 'Less than 1 day',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB Used',
  '移动已用': 'Mobile Used',
  '调整限额': 'Adjust Limit',
  '收银': 'Sell',
  '物流': 'In&Out',
  '公告': 'Announcement',
  '储位': 'Storage',
  '其他': 'Other',
  '授权模块': 'Authory Module',
  '清理闲置设备': 'Clean Up Idle Device',
  '最近登录日期': 'Last Login Date',
  '未登录天数': 'Not Logged Days',
  '机器编码': 'Machine Code',
  '未登录天数大于': 'Not Logged Days More than',
  '请输入或选择': 'Enter/Select',
  '解绑全部': 'Unbind ALL',
  '将批量解绑所有设备，是否确认操作': 'To unbind all devices in batches, sure to do this?',
  // 4.2
  '设备变更记录': 'Change Record',
  '收银员帐号': 'Cashier Acct',
  '请输入收银员账号': 'Enter Cashier Acct',
  '设备解绑记录': 'Unbundling Record',
  '合同变更记录': 'Contract Change Record',
  '不限': 'Un-Limit',
  '设备归属列表': 'Device Belonging List',
  '创建合同': 'Create Contract',
  '合同初始化': 'Contract Initialize',
  '更新设备授权': 'Update Device Authory',
  '更新店铺数量': 'Update Channel No.',
  '续约': 'Renew',
  '模块配置': 'Module Manage',
  '更新Webpos数量': 'Update WEBPOS No.',
  '移动POS数量': 'Mobile POS No.',
  '授权店铺数量': 'Authory Channel NO.',
  '更新合同服务日期': 'Update Contract Date',
  '店铺': 'Channel',
  'Webpos限额': 'Webpos Limitation',
  '请输入限额': 'Input Limit',
  '移动POS限额': 'Mobile POS Limitation',
  '必须为正整数': 'Must be A Positive Integer',
  '不能低于': 'Not Lower Than',
  '归属店铺': 'Channel Belonging',
  '取消归属': 'Cancel Belonging',
  '全部': 'all',
  '合同类型': 'Contract Type',
  '租用': 'Rent',
  '购买': 'Buy-out',
  '导出': 'Export',
  '文件大小不能超过1M！': 'The file can not exceed 1M',
  '店务': 'shop'
}


// WEBPACK FOOTER //
// ./src/i18n/en/contract.js